<template>
  <b-nav-item-dropdown right no-caret>
    <template slot="button-content">
      <i class="fa fa-cog big-icon"></i>
    </template>
    <b-dropdown-header tag="div" class="text-center">{{ $t('top.signed_in_as') + ' '}}<br>
      <strong><h6>{{user_name}}</h6></strong>
    </b-dropdown-header>
    <b-dropdown-item @click="settings()"><i class="fa fa-user-o"></i> {{ $t('top.settings') }}
    </b-dropdown-item>
    <b-dropdown-item @click="logout()"><i class="fa fa-lock"></i> {{ $t('top.logout') }}</b-dropdown-item>
  </b-nav-item-dropdown>
</template>
<style>
  .big-icon {
    font-size: 21px;
  }
</style>
<script>
  export default {
    name: 'header-dropdown-accnt',
    components: {
    },
    data: () => {
      return {
        user_name: ''
      }
    },
    created () {
      let vm = this
      let auth = this.$auth.user()
      let userInfo = auth.user_info.user
      let userName = userInfo.name
      vm.user_name = userName
    },
    methods: {
      settings: function () {
        this.$router.push({'name': 'Profile'})
      },
      logout: function () {
        if (localStorage.getItem('default_auth_token') === null) {
          this.$router.push('login')
          return
        }
        localStorage.removeItem('clientID')
        this.$Progress.start()
        this.$auth.logout({
          makeRequest: true,
          success: function (response) {
            this.$Progress.finish()
          },
          error: function (error) {
            this.$Progress.fail()
            console.log(error)
          },
          redirect: '/login'
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Header/HeaderDropdownAccnt.vue